module.exports = __webpack_public_path__ + "static/img/titlog.72ae98a6.png";